// Saves a print resolution (e.g. 300 DPI for passport photos) in a JPG's JFIF header.

/** Returns a copy of the JPG with its JFIF density set to `dpi` (inserting a
 *  JFIF header if the encoder didn't write one). Other formats are returned as is. */
export function setJpegDpi(bytes: Uint8Array, dpi: number): Uint8Array {
  if (bytes[0] !== 0xff || bytes[1] !== 0xd8) return bytes;
  const d = Math.max(1, Math.min(65535, Math.round(dpi)));
  const hasJfif =
    bytes[2] === 0xff &&
    bytes[3] === 0xe0 &&
    String.fromCharCode(...bytes.subarray(6, 11)) === "JFIF\0";

  if (hasJfif) {
    const out = bytes.slice();
    out[13] = 1; // units: dots per inch
    out[14] = d >> 8;
    out[15] = d & 0xff;
    out[16] = d >> 8;
    out[17] = d & 0xff;
    return out;
  }
  const app0 = new Uint8Array([
    0xff,
    0xe0,
    0x00,
    0x10,
    0x4a,
    0x46,
    0x49,
    0x46,
    0x00,
    0x01,
    0x01,
    0x01,
    d >> 8,
    d & 0xff,
    d >> 8,
    d & 0xff,
    0x00,
    0x00,
  ]);
  const out = new Uint8Array(bytes.length + app0.length);
  out.set(bytes.subarray(0, 2), 0);
  out.set(app0, 2);
  out.set(bytes.subarray(2), 2 + app0.length);
  return out;
}

/** The JFIF density in DPI, or null (used by tests and the result panel). */
export function readJpegDpi(bytes: Uint8Array): number | null {
  const isJfif =
    bytes[2] === 0xff &&
    bytes[3] === 0xe0 &&
    String.fromCharCode(...bytes.subarray(6, 11)) === "JFIF\0";
  if (!isJfif || bytes[13] !== 1) return null;
  return (bytes[14] << 8) | bytes[15];
}
